import AzImg from '~/components/Atoms/AzImg.vue';
export default defineComponent({
  name: 'BlockImage',
  components: {
    AzImg: AzImg
  },
  props: {
    image: {
      type: Object,
      required: true
    },
    alignment: {
      type: String,
      default: 'left'
    },
    size: {
      type: String,
      default: 'actual'
    }
  },
  setup: function setup(props) {
    var dimensions = computed(function () {
      switch (props.size) {
        case 'small':
          return '344x202';
        case 'medium':
          return '586x316';
        default:
          return '674x426';
      }
    });
    return {
      dimensions: dimensions
    };
  }
});